module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-04"
  }, [_c('i', [_vm._v("Certain women made us astonished")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm-05"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LUKE 24:22")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-06"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAVID")]), _vm._v(": "), _c('i', [_vm._v("You sound so certain")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm-06"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABIGAIL")]), _vm._v(": "), _c('i', [_vm._v("I am")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61884eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 72
// module chunks = 0